/**
 * E3 (0056) · Reprogramar o vencimento de uma obrigação do Contas a Pagar, com motivo (registro só de inclusão; o
 * vencimento original e o histórico ficam preservados). Usado na ficha da obrigação e na projeção do Fluxo de caixa.
 */
import { useEffect, useState } from 'react';
import { api } from '../api.ts';
import { Modal } from '../comercial/ui.tsx';
import { Campo } from '../componentes/basicos.tsx';
import { dataBr, plural } from './ContasPagar.tsx';

/** Reprogramar o vencimento de uma obrigação do Pagar, com motivo (registro só de inclusão; original preservado). */
export function ReprogramarVencimento({ obrigacao, vencimento, descricao, aoFechar, aoConcluir }: { obrigacao: string; vencimento: string; descricao: string; aoFechar: () => void; aoConcluir: () => void }) {
  const [novo, setNovo] = useState('');
  const [motivo, setMotivo] = useState('');
  const [previa, setPrevia] = useState<{ anterior: string; novo: string; original: string; reprogramacoes: number } | null>(null);
  const [erro, setErro] = useState('');
  const [enviando, setEnviando] = useState(false);
  useEffect(() => setPrevia(null), [novo, motivo]);
  const ok = Boolean(novo) && novo !== vencimento && motivo.trim().length >= 10;
  const enviar = async (comPrevia: boolean) => {
    setEnviando(true);
    setErro('');
    try {
      const r = await api.post<{ anterior: string; novo: string; original: string; reprogramacoes: number }>(`/api/contas-pagar/obrigacoes/${obrigacao}/reprogramar`, { vencimento: novo, motivo, previa: comPrevia });
      if (comPrevia) setPrevia(r);
      else aoConcluir();
    } catch (e) {
      setErro((e as Error).message);
    } finally {
      setEnviando(false);
    }
  };
  return (
    <Modal
      titulo={`Reprogramar vencimento — ${obrigacao}`}
      aoFechar={aoFechar}
      medio
      rodape={
        <>
          <span className="texto-secundario conc-rodape-efeito">{previa ? 'Confira e confirme.' : 'Nada é gravado até confirmar.'}</span>
          <button type="button" className="botao-secundario" onClick={aoFechar}>
            Voltar
          </button>
          {previa ? (
            <button type="button" className="botao-primario" disabled={!ok || enviando} onClick={() => void enviar(false)} data-teste="confirmar-reprogramar">
              Reprogramar
            </button>
          ) : (
            <button type="button" className="botao-primario" disabled={!ok || enviando} onClick={() => void enviar(true)} data-teste="previa-reprogramar">
              Ver prévia
            </button>
          )}
        </>
      }
    >
      <div data-teste="modal-reprogramar">
        <p className="faixa-resumo-modal">
          <span>
            {descricao} · vencimento atual <strong>{dataBr(vencimento)}</strong>
          </span>
        </p>
        <div className="grade-form duas">
          <Campo rotulo="Novo vencimento *">{(id) => <input id={id} type="date" value={novo} onChange={(e) => setNovo(e.target.value)} data-teste="novo-vencimento" />}</Campo>
        </div>
        <Campo rotulo="Motivo *" dica="Fica no histórico da obrigação; o vencimento original é preservado.">
          {(id) => <textarea id={id} rows={2} maxLength={500} value={motivo} onChange={(e) => setMotivo(e.target.value)} placeholder="Ao menos 10 caracteres" data-teste="motivo-reprogramar" />}
        </Campo>
        {previa && (
          <p className="faixa-resumo-modal" data-teste="previa-reprogramacao">
            <span>
              {dataBr(previa.anterior)} → <strong>{dataBr(previa.novo)}</strong> · original {dataBr(previa.original)} · {plural(previa.reprogramacoes, 'reprogramação', 'reprogramações')} no histórico (prévia, nada gravado)
            </span>
          </p>
        )}
        {erro && (
          <p className="aviso aviso-erro" role="alert" data-teste="erro-reprogramar">
            {erro}
          </p>
        )}
      </div>
    </Modal>
  );
}
